export * from './app-header.component';



// WEBPACK FOOTER //
// /var/www/portaldev/bullseye/src/app/components/app-header/index.ts